export default __webpack_public_path__ + "static/media/Wordpress_Vein_Clinic_Center_Washington_DC_Vein_Doctors_McLean_VA.f9c8d8ef.png";